import clsx from 'clsx';
import { format } from 'date-fns';
import { toUpper } from 'lodash';
import moment from 'moment/moment';
import React, { useEffect, useState } from 'react';

import { RedeemFrequentPassageRequestButton } from '@shared/frequent-passage-requests/components/RedeemFrequentPassageRequestButton';

import { FrequentPassageRequest } from '../../../../hooks/api/utils/types';

type Props = {
  frequentPassageRequest: FrequentPassageRequest;
};

// Status "redeemable" with remark OR "already picked up (sticker ID)"

export default function FrequentPassageRequestDetails(props: Props) {
  const [frequentPassageRequest, setFrequentPassageRequest] = useState<FrequentPassageRequest>(
    props.frequentPassageRequest
  );
  const [redeemedJustNow, setRedeemedJustNow] = useState<boolean>(false);

  useEffect(() => {
    setRedeemedJustNow(false);
    setFrequentPassageRequest(props.frequentPassageRequest);
  }, [props.frequentPassageRequest]);

  function handleRedeemed(frequentPassageRequest: FrequentPassageRequest) {
    setFrequentPassageRequest(frequentPassageRequest);
    setRedeemedJustNow(true);
  }

  return (
    <div className="m-portlet__body">
      <div className="m-widget13">
        <div className="m-widget13__item">
          <span className="m-widget13__desc m--align-right">Sticker type</span>
          <span className="m-widget13__text m-widget13__text-bolder m--font-brand">
            {frequentPassageRequest.frequentPassageStickerType.name}
          </span>
        </div>
        <div className="m-widget13__item">
          <span className="m-widget13__desc m--align-right">Company Name</span>
          <span className="m-widget13__text m-widget13__text-bolder">
            {frequentPassageRequest.registration.company?.name}
          </span>
        </div>
        <div className="m-widget13__item">
          <span className="m-widget13__desc m--align-right">Crew Member</span>
          <span className="m-widget13__text m-widget13__text-bolder">
            {frequentPassageRequest.crewMember?.user?.fullName}
            {!frequentPassageRequest.crewMember && (
              <span className="m-badge m-badge--danger m-badge--wide">Not linked to crew member yet</span>
            )}
          </span>
        </div>
        <div className="m-widget13__item">
          <span className="m-widget13__desc m--align-right">Vehicle</span>
          <span className="m-widget13__text m-widget13__text-bolder">
            {frequentPassageRequest.vehicleType}{' '}
            {frequentPassageRequest.licensePlate && <>({toUpper(frequentPassageRequest.licensePlate)})</>}
          </span>
        </div>
        <div className="m-widget13__item">
          <span className="m-widget13__desc m--align-right">Status</span>
          <span className="m-widget13__text">
            <span
              className={clsx('m-badge m-badge--wide', {
                'm-badge--danger':
                  (frequentPassageRequest.status === 'redeemed' && !redeemedJustNow) ||
                  frequentPassageRequest.status === 'rejected' ||
                  frequentPassageRequest.status === 'pending',
                'm-badge--success':
                  frequentPassageRequest.status === 'approved' ||
                  (redeemedJustNow && frequentPassageRequest.status === 'redeemed'),
              })}
            >
              {frequentPassageRequest.status}
            </span>
            {frequentPassageRequest.status === 'redeemed' && (
              <p className="mt-2">
                This frequent passage request was redeemed on{' '}
                {moment.utc(frequentPassageRequest.redeemedAt!).local().format('DD/MM/YYYY HH:mm')}.
              </p>
            )}
            {frequentPassageRequest.status === 'pending' && (
              <p className="mt-2">
                This frequent passage request has not been approved yet! Please wait until the crew office approves this
                frequent passage request.
              </p>
            )}
          </span>
        </div>
        {frequentPassageRequest.remark && (
          <div className="m-widget13__item">
            <span className="m-widget13__desc m--align-right">Remark</span>
            <span className="m-widget13__text">{frequentPassageRequest.remark}</span>
          </div>
        )}
        <div className="m-widget13__item">
          <span className="m-widget13__desc m--align-right"></span>
          <span className="m-widget13__text m-widget13__text-bolder">
            {frequentPassageRequest.canRedeem && (
              <RedeemFrequentPassageRequestButton
                frequentPassageRequest={frequentPassageRequest}
                onRedeem={(frequentPassageRequest) => handleRedeemed(frequentPassageRequest)}
              />
            )}
          </span>
        </div>
        {/*<div className="m-widget13__action m--align-right">*/}
        {/*    */}
        {/*</div>*/}
      </div>
    </div>
  );
}
